import User from 'models/User'
import userService from 'services/user.service'
import { useCookies } from "vue3-cookies";
import { useToast } from "vue-toastification"
import i18n from 'i18n';

const toast = useToast();
const { cookies } = useCookies();
const basePath = process.env.VUE_APP_BASE_URL;


const state = {
    user: {
        id: 0,
        name: "",
        type: "unauthorized",
        roles: [],
        permissions: [],
        token: null
    }
}

// getters
const getters = {
    isAuth: state => {
        return state.user.id > 0;
    },
    hasPermission: state => permission => {
        if(!Array.isArray(state.user.permissions))
            return false;
        return state.user.permissions.indexOf(permission) !== -1;
    }  
}

// mutations
const mutations = {
    setUser (state, userInfo = null) {
        state.user = new User(userInfo)
    }
}

// actions
const actions = {
    login ({ commit }, payload) {
        userService.login(payload.credentials).then(user => {
            commit('setUser', user)
            cookies.set("user", user, '120min', basePath);
            const redirectPath = localStorage.getItem('redirectAfterLogin');
            if(redirectPath){
                localStorage.removeItem('redirectAfterLogin');
                location.href = redirectPath;
            }else{
                payload.router.push({name:'dashboard'})
            }
            
        })
    },
    
    logout ({ commit }, router) {
        const user = {
            id: 0,
            name: "",
            type: "unauthorized",
            roles: [],
            permissions: [],
            token: null
        };
        userService.logout().then(() => {
            commit('setUser', new User(user))
            cookies.remove('user', basePath);
            localStorage.removeItem('redirectAfterLogin');
            router.push({name:'home'})
        }).catch(() => {
            commit('setUser', user);
            cookies.remove('user', basePath);
            localStorage.removeItem('redirectAfterLogin');
            router.push({name:'home'})
        })
    },
    
    checkUserBySession({ commit }, router) {
        userService.getUserBySession().then(user => {
            commit('setUser', user)
        }).catch(() => {
            cookies.remove('user', basePath);
        })
    },

    checkUserByToken({ commit }, payload) {
        userService.getUserByToken(payload.token).then(user => {
            commit('setUser', user)
        })
    },

    getUserBySession({ commit }, router) {
        userService.getUserBySession().then(user => {
            commit('setUser', user)
        }).catch(() => {
            localStorage.setItem('redirectAfterLogin', location.href);
            router.push({name:'home'})
        })
    },

    getUserByToken({ commit }, payload) {
        userService.getUserByToken(payload.token).then(user => {
            commit('setUser', user)
        }).catch(() => {
            payload.router.push({name:'home'})
        })
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
